import { EntityService } from "src/app/core/services/entity.service";
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LookupDetail } from "src/app/core/models/lookup-detail.model";
import { LookupCreate } from "src/app/core/models/lookup-create.model";

@Injectable({
  providedIn: 'root'
})
export class LiftBoardService extends EntityService<LookupDetail, LookupDetail, LookupDetail, LookupCreate> {
  constructor(
    httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    super(httpClient, baseUrl + 'api/liftBoard');
  }
}
